module.exports = __webpack_public_path__ + "static/img/home_func3.507ca9bd.png";